import React, { Component, Fragment } from 'react';
import { Row } from 'antd';
import { withAsyncActions } from 'react-async-client';

import { getCities } from 'actions/asyncActions';
import { MapContainer } from '../distributors/MapContainer';
@withAsyncActions(() => ({
    getCities: getCities.withOptions({ dispatchOnMount: true })
}))
export default class ApplicationDistributorSelect extends Component {
   
    geoCode = {
        lat: 55.753559,
        lng: 37.609218
    }

    render() {
        const { location } = this.props.regionPath
        const { getCities: { data } } = this.props
        const projectRegion = location.split('/').pop()

        if(data.length) this.geoCode =  data.find(item => item.city.toLowerCase() === projectRegion) || this.geoCode
        
        return (
            <Fragment>
                <Row className="distributor-selects" gutter={20}>
                    <MapContainer field={this.props} geoCode={this.geoCode} cities={data} city={projectRegion}/>
                </Row>
            </Fragment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/pages/projects/application/ApplicationDistributorSelect.js